import { render, staticRenderFns } from "./Receiver.vue?vue&type=template&id=1585eff2&"
import script from "./Receiver.vue?vue&type=script&lang=js&"
export * from "./Receiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports